let moduleVersion = "2.4.19";
export const getCurrentVersion = () => moduleVersion;
export const setCurrentVersion = version => {
  moduleVersion = version;
};
